// Libraries
import React from 'react';

// Supermove
import {Icon} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {FileModel} from '@supermove/models';

// App
import Tag from '@shared/design/components/Tag';
import {getIconFromExtension} from 'modules/Communication/Email/utils/getAttachmentIcon';

const FileTag = ({
  file,
  isError,
  onPress,
}: {
  file?: FileModel;
  isError?: boolean;
  onPress?: () => void;
}) => {
  const extension = file?.filename?.split('.').pop();
  const icon = isError
    ? Icon.FileCircleExclamation
    : getIconFromExtension(extension?.toLowerCase());
  const displayName =
    file?.name && file.name.length > 10 ? `${file.name.slice(0, 10)}...` : (file?.name ?? '');

  return <Tag label={displayName} iconLeft={icon} hasWarning={isError} onPress={onPress} />;
};

// --------------------------------------------------
// Data
// --------------------------------------------------
FileTag.fragment = gql`
  fragment FileTag on File {
    id
    name
    filename
  }
`;

export default FileTag;
